import { LoyaltyHomeScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <LoyaltyHomeScreen variation="modal" />;
}
